import { defineMessages } from 'react-intl';

export const messages: {
    connectorsErrorFallback: {
        id: string;
        defaultMessage: string;
        description: string;
    }; collaborationTop5ErrorFallback: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	connectorsErrorFallback: {
		id: 'twg-microsite.loggedInView.connectorsErrorFallback',
		defaultMessage: 'Error loading ConnectorsSection',
		description: 'Error fallback shown when the connectors section fails to load',
	},
	collaborationTop5ErrorFallback: {
		id: 'twg-microsite.loggedInView.collaborationTop5ErrorFallback',
		defaultMessage: 'Error loading CollaborationTop5Section',
		description: 'Error fallback shown when the top collaborators section fails to load',
	},
});
